import Triggerable from "metabase/components/Triggerable";
import Popover from "metabase/components/Popover";

/**
 * @deprecated use Popover + useState
 */
export default Triggerable(Popover);
